import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import configureStore from "./stores/configureStore";
import ReactGA from "react-ga";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";
import "./index.css";

const store = configureStore();
ReactGA.initialize("UA-0000000-0");

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);
if (module.hot) {
  module.hot.accept("./App", () => {
    ReactDOM.render(
      <Provider store={store}>
        <App />
      </Provider>,
      document.getElementById("root")
    );
  });
}

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js